import { render, staticRenderFns } from "./Block.vue?vue&type=template&id=4189d4bb&scoped=true"
import script from "./Block.vue?vue&type=script&lang=js"
export * from "./Block.vue?vue&type=script&lang=js"
import style0 from "./Block.vue?vue&type=style&index=0&id=4189d4bb&prod&lang=scss&scoped=true"
import style1 from "./Block.vue?vue&type=style&index=1&id=4189d4bb&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4189d4bb",
  null
  
)

export default component.exports